const WORKBENCHES = [
  {
    id:'agent',
    label: 'Agent工作台',
    route:null,
    children:[
      {id:'dou-agent',key:'agent.douyin',label: '抖店Agent自动化'},
      {id:'wx-agent',key:'agent.wechat',label: '微店Agent自动化'},
    ]
  },
  {
    id: 'shop',
    label: '店铺工作台',
    route: '/new_uc_shop_manage',
    children: [
      { id: 'douyin-mgmt', key: 'shop.douyin', label: '抖店管理 / 抖店列表', query: { shop_type: '1' } },
      { id: 'weixin-mgmt', key: 'shop.wechat', label: '微店管理 / 微店列表', query: { shop_type: '7' } },
      { id: 'dou-mg', key: 'shop.douyin_manage', label: '抖店管理 / 我的商品' },
      { id: 'dou-batch', key: 'shop.douyin_batch_modify', label: '抖店管理 / 批量修改' },
      { id: 'dou-opt', key: 'shop.douyin_optimize', label: '抖店管理 / 抖店优化' },
      { id: 'wx-mg', key: 'shop.wechat_manage', label: '微店管理 / 我的商品' },
      { id: 'wechat-category', key: 'shop.wechat_category', label: '微信类目' }
    ]
  },
  {
    id: 'finance',
    label: '财务工作台',
    route: '/new_finance_workbench',
    children: [
      { id: 'shop-data', key: 'finance.shop_data', label: '店铺数据' },
      { id: 'purchase', key: 'finance.purchase', label: '采购管理' },
      { id: 'reimburse', key: 'finance.reimburse', label: '报销管理' },
      { id: 'wallet', key: 'finance.wallet', label: '我的钱包' }
    ]
  },
  {
    id: 'ops',
    label: '运营工作台',
    route: '/new_ops_workbench',
    children: [
      { id: 'ops-shop', key: 'ops.shop_board', label: '店铺看板' },
      { id: 'ops-goods', key: 'ops.product_board', label: '商品看板' },
      { id: 'ops-task', key: 'ops.task', label: '任务大厅' },
      { id: 'ops-template', key: 'ops.task_template', label: '任务模板' }
    ]
  },
  {
    id: 'select',
    label: '选品工作台',
    route: '/new_select_workbench',
    children: [
      { id: 'select-main', key: 'select.main', label: '星人选品' },
      { id: 'select-ai-dir', key: 'select.ai_dir', label: 'AI定方向' },
      { id: 'select-ai-find', key: 'select.ai_find', label: 'AI找同款' },
      { id: 'select-1688', key: 'select.1688', label: '1688选品' },
      { id: 'select-1688-work', key: 'select.1688_work', label: '1688AI工作台' }
    ]
  },
  {
    id: 'cloud',
    label: '云库工作台',
    route: '/new_cloud_workbench',
    children: [
      { id: 'cloud', key: 'cloud.library', label: '云商品库' },
      { id: 'check-keyword', key: 'cloud.check_keyword', label: '云品检测管理 / 关键词检测' },
      { id: 'check-sku', key: 'cloud.check_sku', label: '云品检测管理 / SKU检测' },
      { id: 'check-img', key: 'cloud.check_img', label: '云品检测管理 / 图片检测' },
      // { id: 'check-title', key: 'cloud.check_title', label: '云品检测管理 / 星人鉴图' },
      { id: 'ai-title', key: 'cloud.ai_title', label: '云品AI优化 / AI标题' },
      { id: 'ai-main-image', key: 'cloud.ai_main_image', label: '云品AI优化 / AI主图' },
      { id: 'ai-product-image', key: 'cloud.ai_product_image', label: '云品AI优化 / AI商品套图' },
      { id: 'ai-white', key: 'cloud.ai_white', label: '云品AI优化 / AI白底图' },
      { id: 'ai-34', key: 'cloud.ai_34', label: '云品AI优化 /AI3/4图' },
      { id: 'ai-video', key: 'cloud.ai_video', label: '云品AI优化 / AI视频' },
      { id: 'batch-modify', key: 'cloud.batch_modify', label: '云品批量修改' },
      { id: 'shelf', key: 'cloud.shelf', label: '商品上架策略' },
      { id: 'blind', key: 'cloud.blind', label: '商品资源盲盒' },
      { id: 'checksku', key: 'cloud.low_price', label: '低价引流' }
    ]
  },
  {
    id: 'goods',
    label: '商品工作台',
    route: '/new_goods_workbench',
    children: [
      { id: 'dou-mg', key: 'goods.douyin_manage', label: '抖店商品 / 我的商品' },
      { id: 'dou-batch', key: 'goods.douyin_batch_modify', label: '抖店商品 / 批量修改' },
      { id: 'dou-opt', key: 'goods.douyin_optimize', label: '抖店商品 / 抖店优化' },
      { id: 'wx-mg', key: 'goods.wechat_manage', label: '微店商品 / 我的商品' }
    ]
  },
  {
    id: 'presales',
    label: '售前工作台',
    route: '/new_presales_workbench',
    children: [
      { id: 'dou-order-mag', key: 'presales.douyin_order_mag', label: '抖店订单 / 订单管理' },
      { id: 'wx-order-mag', key: 'presales.wechat_order_mag', label: '微店订单 / 订单管理' }
    ]
  },
  {
    id: 'aftersales',
    label: '售后工作台',
    route: '/new_aftersales_workbench',
    children: [
      { id: 'dou-after-mag', key: 'aftersales.douyin_manage', label: '抖店售后 / 售后管理' },
      { id: 'dou-after-config', key: 'aftersales.douyin_config', label: '抖店售后 / 售后配置' },
      { id: 'wx-after-mag', key: 'aftersales.wechat_manage', label: '微店售后 / 售后管理' },
      { id: 'wx-after-config', key: 'aftersales.wechat_config', label: '微店售后 / 售后配置' },
    ]
  },
  {
    id: 'system',
    label: '系统工作台',
    route: '/new_system_workbench',
    children: [
      { id: 'ticket', key: 'system.ticket', label: '工单管理' },
      { id: 'roles', key: 'system.roles', label: '岗位管理', hostOnly: true },
      { id: 'staff', key: 'system.staff', label: '员工管理', hostOnly: true },
      { id: 'profile', key: 'system.profile', label: '个人设置' }
    ]
  }
]

const LEGACY_ROUTES = [
  { id: 113, route: '/ucenter_legacy' },
  { id: 133, route: '/uc_statistic' },
  { id: 1341, route: '/uc_shop_board' },
  { id: 1342, route: '/uc_product_board' },
  { id: 1343, route: '/uc_task_hall' },
  { id: 120, route: '/uc_goods' },
  { id: 120, route: '/uc_goods2' },
  { id: 126, route: '/uc_dd_host' },
  { id: 131, route: '/uc_product' },
  { id: 135, route: '/uc_optimization' },
  { id: 1321, route: '/uc_check' },
  { id: 1322, route: '/uc_checkSku' },
  { id: 117, route: '/uc_shangjia' },
  { id: 130, route: '/uc_blindBox' },
  { id: 115, route: '/uc_order' },
  { id: 115, route: '/uc_order2' },
  { id: 136, route: '/uc_after_sales' },
  { id: 136, route: '/uc_after' },
  { id: 137, route: '/uc_after_sale_address' },
  { id: 128, route: '/uc_pdd_manage' },
  { id: 138, route: '/uc_reimbursement' },
  { id: 139, route: '/uc_ticket' },
  { id: 116, route: '/uc_wallet' },
  { id: 129, route: '/uc_position', hostOnly: true },
  { id: 127, route: '/uc_employee', hostOnly: true },
  { id: 118, route: '/uc_setting' }
]

export function isHostAccount(value) {
  return value === true || value === 1 || value === '1' || value === 'true'
}

export function parsePermissionKeys(value) {
  if (!value || value === '000000') return []
  return String(value).split(',').map((key) => key.trim()).filter(Boolean)
}

export function getWorkbench(id) {
  return WORKBENCHES.find((workbench) => workbench.id === id)
}

export function getWorkbenchByRoute(route) {
  return WORKBENCHES.find((workbench) => workbench.route === route)
}

export function getAllowedChildren(workbenchId, access, isHost) {
  const workbench = getWorkbench(workbenchId)
  if (!workbench) return []
  const keys = new Set(parsePermissionKeys(access))
  return workbench.children.filter((item) => {
    if (item.hostOnly) return isHostAccount(isHost)
    return isHostAccount(isHost) || keys.has(item.key)
  })
}

export function getAllowedWorkbenches(access, isHost) {
  return WORKBENCHES.filter((workbench) => getAllowedChildren(workbench.id, access, isHost).length > 0)
}

export function filterWorkbenchItems(workbenchId, items, access, isHost) {
  const allowedIds = new Set(getAllowedChildren(workbenchId, access, isHost).map((item) => item.id))
  return items.reduce((result, item) => {
    if (item.children) {
      const children = item.children.filter((child) => allowedIds.has(child.id))
      if (children.length) result.push({ ...item, children })
    } else if (allowedIds.has(item.id)) {
      result.push(item)
    }
    return result
  }, [])
}

export function getPermissionTree() {
  return WORKBENCHES.map((workbench) => ({
    menu_id: `new.${workbench.id}`,
    title: workbench.label,
    children: workbench.children
      .filter((item) => !item.hostOnly)
      .map((item) => ({ menu_id: item.key, title: item.label }))
  })).filter((workbench) => workbench.children.length > 0)
}

export function getNewUiLocation(workbench, child) {
  const query = { ...(child.query || {}) }
  if (!child.query && workbench.children.length > 1) query.menu = child.id
  return Object.keys(query).length ? { path: workbench.route, query } : { path: workbench.route }
}

export function getFirstNewUiLocation(access, isHost, workbenchId) {
  const workbenches = workbenchId ? [getWorkbench(workbenchId)].filter(Boolean) : getAllowedWorkbenches(access, isHost)
  for (const workbench of workbenches) {
    const child = getAllowedChildren(workbench.id, access, isHost)[0]
    if (child) return getNewUiLocation(workbench, child)
  }
  return null
}

export function resolveRequestedNewUiChild(workbench, query) {
  if (!workbench) return null
  if (workbench.id === 'shop') {
    if (query?.menu === 'wechat-category') return workbench.children.find((item) => item.id === 'wechat-category') || null
    return workbench.children.find((item) => String(item.query?.shop_type || '') === String(query?.shop_type || '')) || null
  }
  if (workbench.children.length === 1 && !query?.menu) return workbench.children[0]
  return workbench.children.find((item) => item.id === query?.menu) || null
}

export function getLegacyPermissionForPath(path) {
  const sorted = [...LEGACY_ROUTES].sort((a, b) => b.route.length - a.route.length)
  return sorted.find((item) => path === item.route || path.startsWith(`${item.route}/`) || path.startsWith(`${item.route}_`)) || null
}

export function getFirstLegacyLocation(access, isHost) {
  const ids = new Set(parsePermissionKeys(access).map(Number))
  const item = LEGACY_ROUTES.find((entry) => {
    if (entry.hostOnly) return isHostAccount(isHost)
    return isHostAccount(isHost) || ids.has(entry.id)
  })
  return item ? item.route : null
}

export function canAccessLegacyPath(path, access, isHost) {
  const permission = getLegacyPermissionForPath(path)
  if (!permission) return true
  if (permission.hostOnly) return isHostAccount(isHost)
  return isHostAccount(isHost) || parsePermissionKeys(access).map(Number).includes(permission.id)
}

export { WORKBENCHES }
